import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from "react";
import styles from "./Chip.module.css";
import { cx } from "../cx";

export type ChipProps = Omit<ButtonHTMLAttributes<HTMLButtonElement>, "children"> & {
  selected?: boolean;
  size?: "medium" | "small";
  children: ReactNode;
};

/** SEED Chip (Figma 38:259). 카테고리 탭·추천 답변. */
export function Chip({ selected = false, size = "medium", className, type = "button", children, ...rest }: ChipProps) {
  return (
    <button
      type={type}
      className={cx(styles.root, styles[size], selected && styles.selected, className)}
      aria-pressed={selected}
      {...rest}
    >
      {children}
    </button>
  );
}

export type StaticChipProps = HTMLAttributes<HTMLSpanElement> & {
  size?: "medium" | "small";
  children: ReactNode;
};

/** 누를 수 없는 정적 칩(플롯 태그 등). 버튼이 아니라 span 이라 스크린리더가 "전환 버튼"으로 읽지 않는다. */
export function StaticChip({ size = "medium", className, children, ...rest }: StaticChipProps) {
  return (
    <span className={cx(styles.root, styles[size], styles.static, className)} {...rest}>
      {children}
    </span>
  );
}
